var cov_30xx8tfgr = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Icon/styles/index.ts",
      hash = "0029f88c6d8868301edce95052724a426ecc3951",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Icon/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var iconLess = {};
import genaration from '../../utils/classname';
export var iconClass = (cov_30xx8tfgr.s[0]++, genaration(iconLess, 'icon'));